import React from "react"
import { withRouter } from "react-router-dom"

function Analytics(props) {
    return (
        <div className="analytics">
            <div className="analytics-grid">
                <div className="analytics-item">
                    <h4 className="analytics-title">Heading 1</h4>
                    <h3 className="analytics-numbers">123,345</h3>
                </div>
                <div className="analytics-item">
                    <h4 className="analytics-title">Heading 1</h4>
                    <h3 className="analytics-numbers">123,345</h3>
                </div>
                <div className="analytics-item">
                    <h4 className="analytics-title">Heading 1</h4>
                    <h3 className="analytics-numbers">123,345</h3>
                </div>
                <div className="analytics-item">
                    <h4 className="analytics-title">Heading 1</h4>
                    <h3 className="analytics-numbers">123,345</h3>
                </div>
                <div className="analytics-item">
                    <h4 className="analytics-title">Heading 1</h4>
                    <h3 className="analytics-numbers">123,345</h3>
                </div>
                <div className="analytics-item">
                    <h4 className="analytics-title">Heading 1</h4>
                    <h3 className="analytics-numbers">123,345</h3>
                </div>
                <div className="analytics-item">
                    <h4 className="analytics-title">Heading 1</h4>
                    <h3 className="analytics-numbers">123,345</h3>
                </div>
                <div className="analytics-item">
                    <h4 className="analytics-title">Heading 1</h4>
                    <h3 className="analytics-numbers">123,345</h3>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Analytics) 
